import React from 'react';
import { useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import completedIcon from '../../../../assets/images/Completed.svg';
import { currencyConvertor, getPONumber, isEclipseOpsTruck } from '../../../../Utils/Utility';
import { injectIntl } from 'react-intl';
import { getFormattedDate } from '../../../Common/DateUtils';

function Completed({ intl, ...props }) {
    const { user } = props;
    const completedData = useSelector(state => state.completed);
    const { formatMessage } = intl;

    return (
        <div className={props.order === 3 ? "tab-pane fade show active" : "tab-pane fade"} id="pills-Completed" role="tabpanel"
            aria-labelledby="pills-Completed-tab">
            {completedData.completedPo?.loads.length > 0 ?
                <div className="custom-tiles-blocks row">
                    {completedData.completedPo.loads.map((item, index) => {
                        return (
                            <div className="col-xs-12 col-xsm-6 col-sm-4 col-xl-4 col-xxl-3" key={index}>
                                <div className="item position-relative">

                                    <div className="contest_info">
                                        <div className="contest_details">
                                            <div className="d-flex justify-content-between align-items-center contest_date">
                                                <span className="contest_title"
                                                    title={formatMessage({ id: "app.control_number" })}>{item.load_control_num}</span>
                                                {
                                                    isEclipseOpsTruck(item) ?
                                                        <span className="contest_title text-danger"
                                                            title={formatMessage({ id: 'app.total_payment_amount' })}>${currencyConvertor(parseFloat(parseFloat(item.total_bill_amount) + parseFloat(item.serviceFee)).toFixed(2))}</span>
                                                        : <span className="contest_title text-danger"
                                                            title={formatMessage({ id: 'app.total_payment_amount' })}>${currencyConvertor(item.total_bill_amount)}</span>
                                                }

                                            </div>

                                        </div>
                                        <div className="description_block">
                                            <div className="d-flex mb-3 align-items-center">
                                                <i
                                                    className="fal fa-map-marker-alt fa-fw"
                                                    style={{ fontSize: "18px" }}
                                                ></i>
                                                <label className="mb-0 eventLocation" title={item.location}>
                                                    {item.location}{" "}
                                                </label>
                                            </div>
                                            {

                                                isEclipseOpsTruck(item) &&
                                                <div className="d-flex mb-3 align-items-center text-success ">
                                                    <img src={completedIcon} alt="" />
                                                    <label className="mb-0 text-danger" title="PO Number" style={{ marginLeft: "12px" }}>
                                                        {getPONumber(item)}</label>

                                                </div>

                                            }

                                            <div className="d-flex mb-3 align-items-center text-success ">
                                                <img src={completedIcon} alt="" />
                                                {item.total_bill_amount === item.total_paid ? <label className="mb-0 text-success" title={formatMessage({ id: "app.payment_successfull" })} style={{ marginLeft: "12px" }}>
                                                    {formatMessage({ id: "app.payment_successfull" })}</label> : <label className="mb-0 text-danger" title={formatMessage({ id: "app.payment_uncollected" })} style={{ marginLeft: "12px" }}>
                                                    {`$${currencyConvertor(item.total_bill_amount - item.total_paid)} ${formatMessage({ id: "app.payment_uncollected" })}`}</label>
                                                }
                                            </div>
                                            <div className="d-flex mb-3 align-items-center">
                                                <i className="fal fa-calendar-alt fa-fw"
                                                    style={{ fontSize: "18px" }}></i>
                                                <label className="mb-0 eventLocation"
                                                    title={item.check_in_time}>
                                                    {/* {item.check_in_time.substring(8, 10)}-{item.check_in_time.substring(5, 7)}-{item.check_in_time.substring(0, 4)} */}
                                                    {getFormattedDate(item.check_in_time)}
                                                </label>
                                            </div>

                                        </div>
                                        <div className="contest_btn_broup">
                                            <Link to={`/completedDetails/${item.load_id}`}
                                                className="btn btn-chartreuse min-width"

                                            >{formatMessage({ id: "app.more_details" })}</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                : <div class="empty_block m-auto">
                    <img src={completedIcon} />
                    <label class="text-center mb-3">{formatMessage({ id: "app.no_completed_load" })}<Link to={{
                        pathname: `/help`
                    }}><b className='text-orange ml-1'>{formatMessage({ id: "app.click_here" })} </b></Link>{formatMessage({ id: "app.load_help" })}</label>
                </div>}
        </div>
    )
}

export default injectIntl(Completed);
